import React from 'react';
import PropTypes from 'prop-types';

function Banner(props)
{
    const message = props.message || '';
    const showBanner = props.showBanner || false;

    return (
        <div>
            <div className={`Banner ${showBanner ? '': 'hidden'}`}>
                {message}
            </div>
        </div>
    );
}

Banner.propTypes = {
    message: PropTypes.string,
    showBanner: PropTypes.bool
};

export default Banner;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Banner.js